import { Role, RoleType } from '@/services/authentication/hooks/user';
import { useParams } from 'react-router';

export const getMspCatalogueLink = (mspId: string) => {
  return `/msps/${mspId}/mspCatalogue`;
};

export const getMyCatalogueLink = (user: Role) => {
  if (user.type === RoleType.Admin) {
    return '/configuratorCatalogue';
  }
  if (user.type === RoleType.Partner) {
    return getMspCatalogueLink(user.partnerId || '-');
  }
  if (user.type === RoleType.Company) {
    return `/msps/${user.partnerId}/companies/${user.customerId}/catalogue`;
  }
  if (user.type === RoleType.CreditChecker) {
    return '';
  }
  throw new Error('Invalid user type');
};

const getPurchaseOrderLink = (partnerId: string, customerId: string, orderId?: string) => {
  const base = `/msps/${partnerId}/companies/${customerId}/purchaseOrders`;
  if (!orderId) {
    return base;
  } else {
    return `${base}/${orderId}`;
  }
};

export const getMyPurchaseOrderLink = (user: Role) => {
  if (user.type === RoleType.Company) {
    if (!user.partnerId) {
      throw Error('Company user must have an associated partner ID');
    }

    if (!user.customerId) {
      throw Error('Company user must have an associated customer ID');
    }

    return getPurchaseOrderLink(user.partnerId, user.customerId);
  } else {
    return '';
  }
};

export const useCurrentPurchaseOrderLink = () => {
  const { companyId, partnerId } = useParams<{ companyId: string; partnerId: string; orderId: string }>();

  if (!partnerId) {
    throw Error('getCurrentPurchaseOrderLink can only be used on a page with a partner ID.');
  }

  if (!companyId) {
    throw Error('getCurrentPurchaseOrderLink can only be used on a page with a customer ID.');
  }

  return getPurchaseOrderLink(partnerId, companyId);
};
